module.exports = __webpack_public_path__ + "static/img/achievement-regular.a89868f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/achievement-regular.png
// module id = DKHJ
// module chunks = 9